module.exports = __webpack_public_path__ + "img/bannerGreen.ab23ee87.jpg";